import api, { authHeaders } from './base';

export const fetchCustomers = async (page = 1, limit = 10, search = '') => {
    const res = await api.get('/customers', {
        headers: authHeaders(),
        params: { page, limit, search: search.trim() || undefined },
    });
    console.log("fetchCustomer", res);
    return res
};

export const fetchStatusCustomers = async (page = 1, limit = 10, type = '', status = '', search = '') => {
    return await api.get('/customers/status', {
        headers: authHeaders(),
        params: { page, limit, type, status, search: search.trim() || undefined },
    });
};

export const fetchCustomerById = async (id) => {
    return await api.get(`/customers/${id}`, { headers: authHeaders() });
};

export const submitCustomerApplication = async (formData) => {
    const { attachments, sketchImageName, ...payload } = formData;
    return await api.post('/customers/', payload, {
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
    });
};

export const updateCustomerApplication = async (id, data) => {
    return await api.put(`/customers/${id}`, data, { headers: authHeaders() });
};

export const updateCustomerByInspectionId = async (id, data) => {
    return await api.put(`/customers/${id}`, data, { headers: authHeaders() });
};

export const updateCustomerMeterById = async (id, data) => {
    return await api.put(`/customers/${id}`, data, { headers: authHeaders() });
};

export const updateCustomerByInstallationId = async (id, data) => {
    return await api.put(`/customers/${id}`, data, { headers: authHeaders() });
};